import { useCallback, useState } from 'react';

export interface UseChatPromptInputOptions {
  initialPrompt?: string;
  onBeforeChange?: (nextPrompt: string) => void;
  onChange?: (nextPrompt: string) => void;
}

export interface ChatPromptInputState {
  prompt: string;
  setPrompt: (nextPrompt: string) => void;
  onPromptChange: (nextPrompt: string) => void;
  resetPrompt: () => void;
}

export const useChatPromptInput = ({
  initialPrompt = '',
  onBeforeChange,
  onChange,
}: UseChatPromptInputOptions = {}): ChatPromptInputState => {
  const [prompt, setPromptState] = useState(initialPrompt);

  const setPrompt = useCallback(
    (nextPrompt: string) => {
      setPromptState(nextPrompt);
      onChange?.(nextPrompt);
    },
    [onChange]
  );

  const onPromptChange = useCallback(
    (nextPrompt: string) => {
      onBeforeChange?.(nextPrompt);
      setPrompt(nextPrompt);
    },
    [onBeforeChange, setPrompt]
  );

  const resetPrompt = useCallback(() => {
    setPrompt(initialPrompt);
  }, [initialPrompt, setPrompt]);

  return {
    prompt,
    setPrompt,
    onPromptChange,
    resetPrompt,
  };
};
